import React, { useEffect, useState } from "react";
import { Row, Spinner } from "reactstrap";
import MediaThumb from "./MediaThumb";
import { useDispatch, useSelector } from "react-redux";
import { listMedia } from "/@src/redux/media/actions";
import { Colxx } from "/@src/components/common/CustomBootstrap";
import orderBy from "lodash/orderBy";
import Pagination from "/@src/containers/pages/Pagination";
import {
  calculateTotalPages,
  paginateArray,
} from "/@src/helpers/paginationHelpers";

function MediaListView({ onMediaSelectChange, selectedMedia }) {
  const dispatch = useDispatch();
  const { mediaList, listMediaLoading } = useSelector((state) => state.media);
  const orderedList = orderBy(mediaList, "updatedAt", "desc");
  useEffect(() => {
    dispatch(listMedia());
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;
  const totalPage = calculateTotalPages(orderedList, pageSize);
  const pageData = paginateArray(orderedList, currentPage, pageSize);

  const onChangePage = (i) => {
    setCurrentPage(i);
  };
  return (
    <Row>
      {!mediaList.length && (
        <Colxx style={{ textAlign: "center" }}>
          {!listMediaLoading && (
            <>
              <h1>No media files yet!</h1>
            </>
          )}
          {listMediaLoading && <Spinner color="primary" />}
        </Colxx>
      )}

      {mediaList &&
        pageData.map((m, i) => (
          <MediaThumb
            key={i}
            media={m}
            selectedMedia={selectedMedia}
            onMediaSelectChange={onMediaSelectChange}
          />
        ))}
      <Pagination
        currentPage={currentPage}
        totalPage={totalPage}
        onChangePage={(i) => onChangePage(i)}
      />
    </Row>
  );
}

export default MediaListView;
